import "bootstrap-cookie-alert/cookiealert";

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

if (getCookie("acceptCookies")) {
	jQuery('#modal-footer-contact-btn').fadeIn();
} else {
	jQuery('#modal-footer-contact-btn').hide();
}
window.addEventListener("cookieAlertAccept", function () {
	jQuery('#modal-footer-contact-btn').fadeIn();
})


// WEBPACK FOOTER //
// ./scripts/autoload/_cookiebar.js